import { useGetConnectedIntegrationWorkspaces } from '@modules/integrationsV2/hooks/useGetConnectedIntegrationWorkspaces';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { IntegrationChannelType, IntegrationType } from 'generated/graphql';
import { UUID } from 'v2/core/entities/uuid';

interface SelectIntegrationWorkspaceProps {
  channelType: IntegrationChannelType;
  integrationType: IntegrationType;
  selectedWorkspaceID: UUID;
  onChange: (workspaceID: UUID) => void;
}

export const SelectIntegrationWorkspace = ({
  channelType,
  integrationType,
  selectedWorkspaceID,
  onChange,
}: SelectIntegrationWorkspaceProps) => {
  const connectedWorkspaces = useGetConnectedIntegrationWorkspaces({
    integrationType,
    channelType,
  });

  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value as string);
  };

  return (
    <FormControl fullWidth>
      <InputLabel id="select-workspace" required>
        Select Workspace
      </InputLabel>
      <Select
        labelId="select-workspace-label"
        id="select-workspace"
        value={selectedWorkspaceID}
        label="Select Workspace"
        onChange={handleChange}
        required
      >
        {connectedWorkspaces.map((workspace) => (
          <MenuItem key={workspace.id} value={workspace.id}>
            {workspace.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
